import {Trans} from "@lingui/react/macro";
import type {GroupRepo} from "../../models/GroupRepo";
import type {UserRepo} from "../../models/UserRepo";
import AppShell from "../../shared/ui/AppShell";
import GroupFooterNav from "../../shared/ui/GroupFooterNav";
import Header from "../../shared/ui/Header";
import MainMenu from "../../shared/ui/MainMenu";
import {Col} from "../../ui/Box";

const GroupMenu = ({groupRepo, userRepo}: {groupRepo: GroupRepo; userRepo: UserRepo}) => {
  const group = groupRepo.vals.useValues();
  return (
    <AppShell
      header={<Header title={<Trans id="nav.menu">Your Groups</Trans>} />}
      footer={<GroupFooterNav current="menu" group={group} />}
    >
      <Col px="12" py="24" flex="auto">
        <MainMenu userRepo={userRepo} />
      </Col>
    </AppShell>
  );
};

export default GroupMenu;
